import { initializeApp } from "firebase/app";
import "firebase/database";

const firebaseConfig = {
	apiKey: "AIzaSyBI9yT81Lu1RysSgusghvOEloexvPao5yg",
	authDomain: "offer-junction.firebaseapp.com",
	databaseURL: "https://offer-junction-default-rtdb.firebaseio.com",
	projectId: "offer-junction",
	storageBucket: "offer-junction.firebasestorage.app",
	messagingSenderId: "223913297176",
	appId: "1:223913297176:web:4ab3e9bd8abafe8d31ca6d",
};

const fire = initializeApp(firebaseConfig);
export default fire;
